import { createContext } from "react";

import type { Session, User } from "@supabase/supabase-js";

export interface SupabaseSessionContextType {
    token: string | null;
    userId: string | null;
    user: User | null;
    session: Session | null | undefined;
    loading: boolean;
    error: Error | null;
}

export const SupabaseSessionContext = createContext<SupabaseSessionContextType>(
    {} as SupabaseSessionContextType,
);
